// extracted by mini-css-extract-plugin
module.exports = {"panel":"AddChildForm_panel__2WCDb","panelTitle":"AddChildForm_panelTitle__2CnTW","panelSubTitle":"AddChildForm_panelSubTitle__6SeVV"};